export interface TrackerConfig {
    id: string;
    name: string;
    type?: "Unit" | "GPS RTK" | "Photo RTK" | "GPS/PHOTO RTK" | "Tablet" | "KYD" | "Sigfox" | "ELSA" | "Offline";
    offlineDelay?: number;
    settings?: any;
    visible?: boolean;
    // Front use only - the templates manager's multi-select (tracker-configs.component.ts).
    selected?: boolean;
}
export const defaultConfig: TrackerConfig = {
    id: '',
    name: '',
    type: 'Unit',
    settings: {}
};
